import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Box from '@mui/material/Box';
import { indigo } from '@mui/material/colors';

import { theme } from 'theme';

import { ESGImpactLabels } from 'shared/constants/ESGImpactLabels';

import { EmptyDataLabel } from 'ui/Labels';
import { BarChart } from 'ui/Charts';
import { useReportPage } from 'shared/hooks';

const { darkCyan, softOrange, verySoftPink, veryLightBlue, black } = theme.palette.custom;

const ESGExternalCostsComparison = ({ entityName, externalCosts, impactType }) => {
  const { t } = useTranslation();

  const [selectedImpactData, setSelectedImpactData] = useState({
    company: externalCosts.companyData[impactType],
    industry: externalCosts.industryData[impactType],
  });

  useEffect(() => {
    setSelectedImpactData({
      company: externalCosts.companyData[impactType],
      industry: externalCosts.industryData[impactType],
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [impactType]);

  const isDataAvailable = externalCosts && externalCosts.companyData && externalCosts.industryData;

  const labels = ESGImpactLabels[impactType].map(label => t(label));

  const datasets = isDataAvailable
    ? [
        {
          label: entityName,
          backgroundColor: [darkCyan, softOrange, verySoftPink, veryLightBlue, black],
          data: Object.values(selectedImpactData.company).map(value => value.toFixed(2)),
          barPercentage: 1.0,
          barThickness: useReportPage ? 20 : 50,
        },
        {
          label: t('Peer group'),
          backgroundColor: indigo[500],
          data: Object.values(selectedImpactData.industry).map(value => value.toFixed(2)),
          barPercentage: 1.0,
          barThickness: useReportPage ? 20 : 50,
        },
      ]
    : [];

  return (
    <>
      {!isDataAvailable ? (
        <Box py={2}>
          <EmptyDataLabel label={t('There are no data available yet.')} />
        </Box>
      ) : (
        <Box mt={2} mx={2}>
          <BarChart
            datasets={datasets}
            labels={labels}
            extraLegendText="In Cents of EUR"
            unit="¢"
            showLegend={false}
          />
        </Box>
      )}
    </>
  );
};

ESGExternalCostsComparison.propTypes = {
  entityName: PropTypes.string.isRequired,
  externalCosts: PropTypes.shape({
    companyData: PropTypes.object.isRequired,
    industryData: PropTypes.object.isRequired,
  }).isRequired,
  impactType: PropTypes.string.isRequired,
};

export default ESGExternalCostsComparison;
